/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Login_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove this login?" |
*
* @param {Profile_Login_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_login_remove_title = /** @type {((inputs?: Profile_Login_Remove_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Login_Remove_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer cet accès ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quitar este acceso?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover este acesso?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere questo accesso?")
	return /** @type {LocalizedString} */ ("Remove this login?")
});